export default "__VITE_PUBLIC_ASSET__ed2ade18__"